<template>
	<nav class="menu-panel" :class="extraRootClasses" @mousedown="stopEvent" @click="stopEvent">
		<div class="menu-panel-body" :class="{ 'menu-panel-iconless': !anyHasIcon }">
			<side-bar-menu-item v-for="item of menu.children" :item="item"></side-bar-menu-item>
		</div>
	</nav>
</template>

<script setup lang="ts">
import type {MenuItemWithChildren} from "@/types/ui/Menu";
import {computed} from "vue";
import {injectEnv} from "@fd/Environment";
import SideBarMenuItem from "@/ui/mouse/SideBarMenuItem.vue";

const props = defineProps<{
	menu: MenuItemWithChildren
}>();
const env = injectEnv();

const anyHasIcon = computed<boolean>(() => {
	for (let item of props.menu.children) {
		if (!!item.icon) return true;
	}
	return false;
});

const extraRootClasses = computed(() => {
	const c: string[] = [];
	return c;
});

/**
 * Stop event bubbling to prevent root element loosing focus
 */
function stopEvent(e:MouseEvent) {
	e.stopPropagation();
}
</script>

<style>
.menu-panel {
	position: absolute;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	min-width: 200px;
	max-width: 98vw;
	max-height: 100vh;
	background-color: var(--bg);
	border: 1px solid var(--menu-border-color);
	border-radius: var(--menu-radius);
	box-shadow: var(--panel-shadow);
	padding: 8px;
	z-index: var(--drop-z-index);
}

.menu-panel-iconless > .menu-item > .menu-fi,
.menu-panel-iconless > .menu-item > .menu-fi-dot {
	display:none;
}
</style>
